module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// EventCalendarViewer Widget

(function (fox, $) {
	'use strict';
	
	fox.registerWidget('Activity_EventCalendarViewer', {

		configure: function () {
			this.defApiConf = {
				widget: 'Api',
				method: 'Activity_Event.get',
				sendTimezone: true,
				cacheChannel: 'event'
			};

			this.registerOptions('', {
				cacheRecordLimit: 500,
				additionalApiParams: {
					transitParameters: {
						v1: 'a3NPKt70Ku'
					}
				},
				widgets: {
					eventFilter: {
						widget: 'Activity_Event_Filter'
					},
					eventList: {
						widget: 'Activity_Event_List',
						wClass: 'Activity_Event_MainEvent'
					},
					getDataApi: this.defApiConf
				},
				handleWom: {
					filterChanged: {
						event: 'filterChanged',
						widget: '#eventFilter',
						callback: 'filterChanged',
						params: {
							alwaysActive: true,
							listenHistory: true
						}
					},
					getDataApiSuccess: {
						event: 'success',
						widget: '#getDataApi',
						callback: 'getDataApiSuccess'
					},
					prepareApi: {
						event: 'prepare',
						widget: '.Api',
						callback: function (obj, performer) {
							// console.time(performer.getAlias());
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.CACHE = {};

			this.registerOptions('#eventFilter', this.getOption('filter'));
			this.registerOptions('#eventList', this.getOption('list'));
		
			this.callParent('init', arguments);
		},

		getCachedApi: function () {
			return this.embedWidget(['api', fox.uniqid()].join('_'), 'Api', fox.merge({
				handleWom: {
					apiSuccess: {
						event: 'success',
						widget: '@this',
						callback: '@parent:cachedApiSuccess'
					},
					apiFail: {
						event: ['error', 'failure'],
						widget: '@this',
						callback: function (o, api) {
							api.removeSelf();
						}
					}
				}
			}, this.defApiConf)).run();
		},

		running: function () {
			this.list = this.rwom1('#eventList');
			this.filter = this.rwom1('#eventFilter');

			this.callParent('running', arguments);
		},

		getCacheHash: function (params) {
			var cl;

			cl = fox.clone(params);

			cl.types = JSON.stringify(cl.types);

			return window.btoa(fox.toArray(cl).join(':'));
		},

		getEvents: function (params) {
			var api = this.rwom1('#getDataApi');
			var additionalParams = this.getOption('additionalApiParams');

			if (!fox.isEmpty(additionalParams)) {

				fox.each(['current', 'next', 'prev'], function(p) {
					if (params[p]) {
						params[p] = fox.merge(params[p], additionalParams);
					}
				}, this);
				
			}

			api.sendHash = this.getCacheHash(params.current);
			api.send(params.current);
		},

		getDataApiSuccess: function (res, api) {
			// console.timeEnd(api.getAlias());
			res = res.answer.response;
			this.addCache(res, api.sendHash).renderList(res);
		},

		renderList: function (collection) {
			this.list.setCollection(collection);
		},

		cachedApiSuccess: function (res, api) {
			// console.timeEnd(api.getAlias());
			res = res.answer.response;
			this.addCache(res, api.sendHash);

			api.removeSelf();
		},

		filterChanged: function (data) {
			var cp, np, pp;

			cp = this.getCacheHash(data.current);
			// np = this.getCacheHash(data.next);
			// pp = this.getCacheHash(data.prev);

			if (this.CACHE.hasOwnProperty(cp)) {
				this.renderList(this.CACHE[cp]);
			}

			// if (!this.CACHE.hasOwnProperty(np)) {this.getCacheData(data, 'next');}
			// if (!this.CACHE.hasOwnProperty(pp)) {this.getCacheData(data, 'prev');}
			if (!this.CACHE.hasOwnProperty(cp)) {this.getEvents(data);}
		},

		getCacheData: function (params, cp) {
			var nApi, pApi;

			switch (cp) {
				case 'next':
					nApi = this.getCachedApi();
					nApi.sendHash = this.getCacheHash(params.next);
					nApi.send(params.next);
					break;
				case 'prev':
					pApi = this.getCachedApi();
					pApi.sendHash = this.getCacheHash(params.prev);
					pApi.send(params.prev);
					break;
				default:
					nApi = this.getCachedApi();
					pApi = this.getCachedApi();

					nApi.sendHash = this.getCacheHash(params.next);
					pApi.sendHash = this.getCacheHash(params.prev);

					nApi.send(params.next);
					pApi.send(params.prev);
			}
		},

		addCache: function (collection, cHash) {
			if (!fox.site.member) {
				collection.unshift({
					widget: 'Activity_Event_JoinBanner',
					template: 'activity_event_card_join'
				});
			}

			if (fox.count(this.CACHE) > this.getOption('cacheRecordLimit')) {this.clearCache();}

			this.CACHE[cHash] = collection;

			return this;
		},

		clearCache: function () {
			var cacheRecords, deadLine;

			cacheRecords = fox.count(this.CACHE);
			deadLine = parseInt(cacheRecords * 0.1);

			fox.each(this.CACHE, function (val, key) {
				if ((cacheRecords--) > deadLine) {
					delete this.CACHE[key];
				}
			}, this);
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/eventCalendarViewer.js
// module id = 827
// module chunks = 4